import { z } from 'zod'

export const assignSplitCategorySchema = z.object({
  categoryId: z.string().guid(),
})

export type AssignSplitCategoryDto = z.infer<typeof assignSplitCategorySchema>
